import { memo, SVGProps } from 'react';

const PolygonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 13 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M6.06218 0.749999C6.25463 0.416666 6.73575 0.416667 6.9282 0.75L12.5574 10.5C12.7498 10.8333 12.5093 11.25 12.1244 11.25H0.866025C0.481124 11.25 0.240563 10.8333 0.433013 10.5L6.06218 0.749999Z'
      fill='white'
    />
  </svg>
);

const Memo = memo(PolygonIcon);
export { Memo as PolygonIcon };
